import { ThemeProvider } from 'styled-components';
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { theme, GlobalStyle } from '../theme/index.js';
import { queryClient } from '../lib/queryClient.js';
import { AuthProvider } from '../lib/AuthProvider.js';
import { ToastHost } from '../components/Toast.js';

/** App-wide providers: theme + global styles, query client, auth, toasts. */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          {children}
          <ToastHost />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
